/**
 * BTS $75 Sale — texture/origin filtering for row and grid layouts.
 *
 * Controls can be duplicated (desktop dropdown + mobile sheet), so every
 * control is redrawn from a single state object rather than from the click
 * target.
 */
(function () {
  function normalize(value) {
    return (value || '').toString().toLowerCase().trim();
  }

  function cardMatches(card, textureFilter, originFilter) {
    var tags = normalize(card.getAttribute('data-tags'));
    var title = normalize(card.getAttribute('data-title'));
    var haystack = tags + ' ' + title;

    if (textureFilter && textureFilter !== 'all') {
      var textureNeedle = normalize(textureFilter);
      if (haystack.indexOf(textureNeedle) === -1) return false;
      // Avoid double-counting Kinky Straight under the generic Straight filter
      if (textureNeedle === 'straight' && haystack.indexOf('kinky straight') !== -1) {
        return false;
      }
    }

    if (originFilter && originFilter !== 'all') {
      var originNeedle = normalize(originFilter);
      if (haystack.indexOf(originNeedle) === -1) return false;
    }

    return true;
  }

  function applyFilter(root, textureFilter, originFilter) {
    var layout = root.getAttribute('data-bts-layout') || 'origin_rows';
    var cards = root.querySelectorAll('[data-bts-card]');
    var visibleTotal = 0;

    cards.forEach(function (card) {
      var match = cardMatches(card, textureFilter, originFilter);
      card.classList.toggle('is-hidden', !match);
      if (match) visibleTotal += 1;
    });

    root.querySelectorAll('[data-bts-row]').forEach(function (row) {
      var visible = 0;
      row.querySelectorAll('[data-bts-card]').forEach(function (card) {
        if (!card.classList.contains('is-hidden')) visible += 1;
      });
      row.classList.toggle('is-empty', visible === 0);
    });

    var emptyMsg = root.querySelector('[data-bts-grid-empty]');
    if (emptyMsg) {
      emptyMsg.classList.toggle('is-hidden', visibleTotal > 0 || layout !== 'filtered_grid');
    }

    return visibleTotal;
  }

  function syncGroup(buttons, attr, value) {
    buttons.forEach(function (btn) {
      var active = (btn.getAttribute(attr) || 'all') === value;
      btn.classList.toggle('is-active', active);
      if (btn.hasAttribute('aria-pressed')) {
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      }
    });
  }

  function labelFor(buttons, attr, value) {
    var label = 'All';
    buttons.forEach(function (btn) {
      if ((btn.getAttribute(attr) || 'all') === value) {
        label = (btn.textContent || '').trim();
      }
    });
    return label;
  }

  /*
   * The theme's WOW library hides `.wow` elements until they scroll into view,
   * which blanks the sale grid on load and after filtering. Detach the cards
   * from it before WOW initialises on DOMContentLoaded.
   */
  function stripReveal(root) {
    root.querySelectorAll('.wow').forEach(function (el) {
      el.classList.remove('wow');
      el.style.visibility = 'visible';
    });
  }

  /*
   * Cards ship a 150px placeholder and rely on lazysizes to swap in the real
   * image once they near the viewport. On this page that reads as products
   * "appearing" as you scroll, and a card revealed by a filter would still be
   * a placeholder. The sale grid is the main content and is small, so resolve
   * its images immediately instead.
   */
  function loadImagesNow(root) {
    root.querySelectorAll('img[data-src]').forEach(function (img) {
      var template = img.getAttribute('data-src');
      if (!template) return;

      var widths = [150, 200, 300, 400, 540, 720];
      try {
        var declared = JSON.parse(img.getAttribute('data-widths') || 'null');
        if (declared && declared.length) widths = declared;
      } catch (e) {
        /* keep defaults */
      }

      var box = img.clientWidth || (img.parentNode && img.parentNode.clientWidth) || 300;
      var target = box * (window.devicePixelRatio || 1);
      var chosen = widths[widths.length - 1];
      for (var i = 0; i < widths.length; i += 1) {
        if (widths[i] >= target) {
          chosen = widths[i];
          break;
        }
      }

      img.src = template.split('{width}').join(chosen);
      img.removeAttribute('data-sizes');
      img.classList.remove('lazyload');
      img.classList.add('lazyloaded');
    });
  }

  function scrollProductsIntoView(root) {
    if (!root || typeof root.scrollIntoView !== 'function') return;
    try {
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } catch (e) {
      root.scrollIntoView(true);
    }
  }

  function init(root) {
    if (!root || root.getAttribute('data-bts-ready') === 'true') return;
    root.setAttribute('data-bts-ready', 'true');

    stripReveal(root);
    loadImagesNow(root);

    var textureBtns = root.querySelectorAll('[data-bts-texture]');
    var originBtns = root.querySelectorAll('[data-bts-origin]');
    if (!textureBtns.length && !originBtns.length) return;

    var filterStyle = root.getAttribute('data-bts-filter-style') || 'inline';
    var countEls = root.querySelectorAll('[data-bts-count]');
    var clearBtns = root.querySelectorAll('[data-bts-clear]');
    var activeCountEls = root.querySelectorAll('[data-bts-active-count]');
    var selects = root.querySelectorAll('[data-bts-select]');
    var drawer = root.querySelector('[data-bts-drawer]');
    var openBtn = root.querySelector('[data-bts-drawer-open]');

    var state = { texture: 'all', origin: 'all' };

    function activeFilterCount() {
      var count = 0;
      if (state.texture !== 'all') count += 1;
      if (state.origin !== 'all') count += 1;
      return count;
    }

    function closeSelects(except) {
      selects.forEach(function (select) {
        if (select === except) return;
        select.classList.remove('is-open');
        var menu = select.querySelector('[data-bts-select-menu]');
        var toggle = select.querySelector('[data-bts-select-toggle]');
        if (menu) menu.hidden = true;
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      });
    }

    function refresh(shouldScroll) {
      var visible = applyFilter(root, state.texture, state.origin);
      var label = visible === 1 ? '1 product' : visible + ' products';

      syncGroup(textureBtns, 'data-bts-texture', state.texture);
      syncGroup(originBtns, 'data-bts-origin', state.origin);

      countEls.forEach(function (el) {
        el.textContent = el.hasAttribute('data-bts-count-verb') ? 'Show ' + label : label;
      });

      var active = activeFilterCount();

      clearBtns.forEach(function (btn) {
        btn.classList.toggle('is-hidden', active === 0);
      });

      activeCountEls.forEach(function (el) {
        el.textContent = active;
        el.classList.toggle('is-hidden', active === 0);
      });

      selects.forEach(function (select) {
        var key = select.getAttribute('data-bts-select');
        var attr = 'data-bts-' + key;
        var buttons = key === 'origin' ? originBtns : textureBtns;
        var valueEl = select.querySelector('[data-bts-select-value]');
        if (valueEl) valueEl.textContent = labelFor(buttons, attr, state[key]);
        select.classList.toggle('is-filtered', state[key] !== 'all');
      });

      if (shouldScroll && (filterStyle === 'inline' || filterStyle === 'grouped')) {
        scrollProductsIntoView(root);
      }
    }

    textureBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.texture = btn.getAttribute('data-bts-texture') || 'all';
        closeSelects();
        refresh(true);
      });
    });

    originBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.origin = btn.getAttribute('data-bts-origin') || 'all';
        closeSelects();
        refresh(true);
      });
    });

    clearBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.texture = 'all';
        state.origin = 'all';
        closeSelects();
        refresh(false);
      });
    });

    selects.forEach(function (select) {
      var toggle = select.querySelector('[data-bts-select-toggle]');
      var menu = select.querySelector('[data-bts-select-menu]');
      if (!toggle || !menu) return;

      toggle.addEventListener('click', function (event) {
        event.stopPropagation();
        var willOpen = menu.hidden;
        closeSelects(select);
        menu.hidden = !willOpen;
        select.classList.toggle('is-open', willOpen);
        toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      });
    });

    if (selects.length) {
      document.addEventListener('click', function (event) {
        if (!root.contains(event.target)) closeSelects();
        else if (!event.target.closest('[data-bts-select]')) closeSelects();
      });
    }

    if (drawer && openBtn) {
      var lastFocused = null;

      var openDrawer = function () {
        lastFocused = document.activeElement;
        drawer.hidden = false;
        document.body.style.overflow = 'hidden';
        openBtn.setAttribute('aria-expanded', 'true');
        var firstChip = drawer.querySelector('.bts-sale-chips__btn');
        if (firstChip) firstChip.focus();
      };

      var closeDrawer = function () {
        drawer.hidden = true;
        document.body.style.overflow = '';
        openBtn.setAttribute('aria-expanded', 'false');
        if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
      };

      openBtn.addEventListener('click', openDrawer);

      drawer.querySelectorAll('[data-bts-drawer-close]').forEach(function (btn) {
        btn.addEventListener('click', closeDrawer);
      });

      document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        if (!drawer.hidden) closeDrawer();
        else closeSelects();
      });
    } else if (selects.length) {
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') closeSelects();
      });
    }

    refresh(false);
  }

  function boot() {
    document.querySelectorAll('[data-bts-products]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target) return;
    var root = event.target.querySelector('[data-bts-products]');
    if (root) init(root);
  });
})();
